export default __webpack_public_path__ + "static/media/blue_marker_linear_sci3_spritesheet.e8a28fd3.png";